export default [
    {
        path: '/scheduler',
        name: 'Scheduler',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Scheduler',
            fullWidth: true,
        },
        components: {
            default: () => import('@views/scheduler/SchedulerIndex.vue'),
            agent: () => import('@views/scheduler/SchedulerIndex.vue'),
        },
    },
    {
        path: '/scheduler/schedule/:id/edit',
        name: 'ScheduleEdit',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Schedule',
        },
        props: {
            default: (route) => ({ id: route.params.id }),
            agent: (route) => ({ id: route.params.id }),
        },
        components: {
            default: () => import('@/views/scheduler/ScheduleEdit.vue'),
            agent: () => import('@/views/scheduler/ScheduleEdit.vue'),
        },
    },
];
